// extracted by mini-css-extract-plugin
export var statItem = "_ha-1";
export var statsRow = "_ha-0";